<template>
  <div>
    <ul class="timeline" id="timeline">
      <!-- <li class="li complete">
        <div class="timestamp">
          <span class="date active">11.00am</span>
        </div>
        <div class="status active d-flex flex-column">
          <h2>Citarasa Medika</h2>
          <span class="desc">
            Memaparkan menu diet yang sesuai untuk penyakit tertentu. Setiap
            episod akan menjemput doktor pakar atau selebriti untuk membantu cef
            dalam penyediaan makanan di...
          </span>
        </div>
      </li> -->
      <li
        class="li complete"
        v-for="(items, idx) in data"
        :key="'epglivetv-' + idx"
      >
        <div v-if="getCurrentEpgDesc(items.dateTimeStart, items.dateTimeEnd)">
          <div class="timestamp">
            <span class="date active">{{
              timeConverter(items.dateTimeStart)
            }}</span>
          </div>
          <div class="status active d-flex flex-column">
            <h2>{{ items.scheduleProgramTitle }}</h2>
            <span class="desc">
              <!-- {{ truncateString(items.scheduleProgramDescription, 150) }} -->
              {{ items.scheduleProgramDescription }}
            </span>
          </div>
        </div>
        <div v-else>
          <div class="timestamp">
            <span class="date">{{ timeConverter(items.dateTimeStart) }}</span>
          </div>
          <div class="status">
            <h4>{{ items.scheduleProgramTitle }}</h4>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'timeline-jadual',
  props: ['data'],
};
</script>

<style scoped>
.timeline {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 0;
  margin-top: 38px;
  overflow-x: auto;
}

.li {
  transition: all 200ms ease-in;
  margin-bottom: 38px;
}
li .active {
  min-width: 300px !important;
}
.date {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.date.active {
  color: #d9e021;
  padding-right: 80%;
}
.timestamp {
  margin-bottom: 20px;
  padding: 0px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 100;
}

.status {
  padding: 16px 8px;
  display: flex;
  justify-content: center;
  border-top: 2px solid #d6dce0;
  position: relative;
  transition: all 200ms ease-in;
}
.status h2 {
  color: #d9e021;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
.status h4 {
  font-weight: 600;
}
.active:before {
  left: 14% !important;
}
.status:before {
  content: '';
  width: 16px;
  height: 16px;
  background-color: white;
  border-radius: 25px;
  border: 1px solid #ddd;
  position: absolute;
  top: -9px;
  left: 42%;
  transition: all 200ms ease-in;
}

.li.complete .status {
  border-top: 2px solid #d9e021;
}
.li.complete .status:before {
  background-color: #d9e021;
  border: none;
  transition: all 200ms ease-in;
}
.li.complete .status h4 {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.li.complete .status .desc {
  color: #fff;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.5px;
  text-align: left;
}

@media (min-device-width: 320px) and (max-device-width: 700px) {
  .timeline {
    list-style-type: none;
    display: block;
  }

  .li {
    transition: all 200ms ease-in;
    display: flex;
    width: inherit;
  }

  .timestamp {
    width: 100px;
  }

  .status:before {
    left: -8%;
    top: 30%;
    transition: all 200ms ease-in;
  }
}
</style>
